import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import * as optionHtmlDocActions from "../../redux/optionHtmlDoc/htmlDoc.actions";
import { useRef } from 'react';
import { useState } from 'react';
import axios from 'axios';
import JoditEditor, { Jodit } from 'jodit-react';
import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "reactstrap";
import { awsBaseUrl } from '../../helper';
import Comment from '../optionHtmlDoc/Comment';
import "../optionHtmlDoc/htmlDoc.css";

const QuestionOptionDocModal = ({ optionHtmlModal, optionHtmlToggle, uuid }) => {

  const [content, setContent] = useState('');
  const [commentModal, setCommentModal] = useState(false);
  const editor = useRef(null);
  let editorValue;
  const dispatch = useDispatch();

  const commentToggle = () => setCommentModal(!commentModal);

  const doc = useSelector(state => state.htmlDocInfo.doc);
  const isCommentStatusChange = useSelector(state => state.htmlDocInfo.isCommentStatusChange);
  const commentList = useSelector(state => state.htmlDocInfo.commentList);
  const user = useSelector(state => state.userInfo.user);
  const prevProps = useRef({ isCommentStatusChange }).current;

  useEffect(() => {
    uploadImageButton();
  }, []);

  useEffect(() => {
    dispatch(optionHtmlDocActions.getOptionHtmlDoc(uuid));
  }, [uuid]);

  useEffect(() => {
    if (Object.keys(doc)?.length > 0) {
      dispatch(optionHtmlDocActions.listCommentHtmlDoc(doc?._id));
    }
  }, [doc]);

  useEffect(() => {
    if (prevProps.isCommentStatusChange !== isCommentStatusChange) {
      if (isCommentStatusChange) {
        dispatch(optionHtmlDocActions.listCommentHtmlDoc(doc?._id));
      }
    }
    return () => {
      prevProps.isCommentStatusChange = isCommentStatusChange;
    }
  }, [isCommentStatusChange]);

  useEffect(() => {
    if (Object.keys(doc)?.length > 0) {
      // console.log("doc", doc);
      setContent(doc?.html);
    }
  }, [doc]);

  const config = {
    placeholder: "Start Typing......",
    "toolbar": true,
    "showCharsCounter": false,
    "showWordsCounter": false,
    "showXPathInStatusbar": false,
    uploader: {
      insertImageAsBase64URI: false,
    },
    extraButtons: ["uploadImage"],
    askBeforePasteHTML: false,
    askBeforePasteFromWord: true, //couse styling issues when pasting from word
    events: {
      afterOpenPasteDialog: (dialog, msg, title, callback) => {
        dialog.close()
        callback()
      },
    }
  }

  const uploadImageButton = () => {
    Jodit.defaultOptions.controls.uploadImage = {
      name: 'Upload image',
      iconURL: "https://www.kindpng.com/picc/m/261-2619141_cage-clipart-victorian-cloud-upload-icon-svg-hd.png",
      exec: (async (editorImg) => {
        await imageUpload(editorImg);
      })
    };
  }

  const imageUpload = (editorImg) => {
    const input = document.createElement('input');
    input.setAttribute('type', 'file');
    input.setAttribute('accept', 'image/*');
    input.click();

    input.onchange = async function () {
      const imageFile = input.files[0];

      if (!imageFile) {
        return;
      }

      if (!imageFile.name.match(/\.(jpg|jpeg|png)$/)) {
        return;
      }

      const imageInfo = await fileUpload(imageFile);
      const imgUrl = await `${process.env.REACT_APP_AWS_BUCKET_BASE_URL}${imageInfo}`;

      insertImage(editorImg, imgUrl);
    }.bind(this);
  };

  const insertImage = (editorImg, url) => {
    const image = editorImg.selection.j.createInside.element('img');
    image.setAttribute('src', url);
    editorImg.selection.insertNode(image);
  }

  const fileUpload = async (file) => {
    // upload image on aws S3
    const imgRes = await axios.post(`${process.env.REACT_APP_BASE_URL}/user/upload/document/pre-signed-url/v1`, {
      sFileName: file.name,
      sContentType: file.type
    }, {
      headers: {
        Authorization: localStorage.getItem('Authorization')
      }
    });
    const url = imgRes.data.data.sUrl
    const sImage = imgRes.data.data.sPath
    await axios.put(url, file, { headers: { "Content-Type": file.type } });

    return sImage;
  }

  const handleBlurEvent = (e) => {
    // console.log("e : ", e);
    editorValue = e;
    setContent(editorValue);
  };

  const handleSaveTemplate = () => {
    // console.log("content", content);
    dispatch(optionHtmlDocActions.saveOptionHtmlDoc(uuid, content));
  }

  return (
    <React.Fragment>
      <Modal isOpen={optionHtmlModal} toggle={optionHtmlToggle} backdrop={"static"} className="modal-xl" centered>
        <ModalHeader style={{ borderBottom: "none" }}>
          <span aria-hidden="true" style={{ position: "absolute", top: "10px", right: "20px", cursor: "pointer", fontSize: "20px" }} onClick={e => optionHtmlToggle()}>x</span>
        </ModalHeader>
        <ModalBody>
          <Button color='success' className='my-3' onClick={e => commentToggle()}>Comments</Button>
          <React.Fragment>
            <JoditEditor
              ref={editor}
              value={content}
              onBlur={newContent => handleBlurEvent(newContent)}
              config={config}
            />
          </React.Fragment>
        </ModalBody>
        <ModalFooter>
          <div style={{ display: "flex", justifyContent: "end", marginTop: "10px" }}>
            {
              <Button color='primary' className='mb-3' onClick={e => {
                setContent(editorValue);
                handleSaveTemplate();
              }}>Save Document</Button>
            }
          </div>
        </ModalFooter>
      </Modal>
      <Comment commentModal={commentModal} commentToggle={commentToggle} doc={doc} commentList={commentList} user={user} />
    </React.Fragment>
  )
};

export default QuestionOptionDocModal;